import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '@app/environment.service';

@Injectable({
  providedIn: 'root'
})
export class InviteService {

  constructor(private http: HttpClient, private environment: EnvironmentService) {}

  public inviteBackpacker(email: string) {
    return this.http.post<any>(`${this.environment.apiUrl}/api/v1/common/backpacker/invite`, { email });
  }

  public inviteReceptionist(email: string) {
    return this.http.post<any>(`${this.environment.apiUrl}/api/v1/common/receptionist/invite`, { email });
  }

  public inviteAffiliate(email: string) {
    return this.http.post<any>(`${this.environment.apiUrl}/api/v1/common/affiliate/invite`, { email });
  }
}
